import React from "react"

import { concatClassNames } from "helpers/jsxHelpers"
import {
	DataTable,
	DataTableBody,
	DataTableCellAlphaNumeric,
	DataTableHead,
	DataTableHeader,
	DataTableRow,
} from "@walmart-web/livingdesign-components"

import useProcessorField from "./useProcessorField"
import { Header, SimpleTableProps } from "./SimpleTable.domain"

import "./SimpleTable.styles.scss"

const SimpleTable = <H extends Header[]>(props: SimpleTableProps<H>) => {
	const { headers, data, className, ...dataTableProps } = props
	const { processColumns, processHeaders } = useProcessorField()

	const mappedHeaders = processHeaders(headers)
	const rows = processColumns(data, headers)

	return (
		<DataTable
			{...dataTableProps}
			UNSAFE_className={concatClassNames(["simple-table", className])}
		>
			<DataTableHead>
				<DataTableRow>
					{mappedHeaders.map(({ value, className }) => (
						<DataTableHeader UNSAFE_className={className} key={value}>
							{value}
						</DataTableHeader>
					))}
				</DataTableRow>
			</DataTableHead>
			<DataTableBody>
				{rows.map((columns, i) => (
					<DataTableRow key={`row-${i}`}>
						{columns.map(({ value, className }, j) => (
							<DataTableCellAlphaNumeric
								UNSAFE_className={className}
								key={`column-${j}-${value}`}
							>
								{value}
							</DataTableCellAlphaNumeric>
						))}
					</DataTableRow>
				))}
			</DataTableBody>
		</DataTable>
	)
}

export default SimpleTable
